var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{class:_vm.$slots.right?'pr-2':'',attrs:{"sm":_vm.compLeftSM,"lg":_vm.compLeftLG}},[_vm._t("default")],2),(_vm.$slots.right)?_c('v-col',{staticClass:"pl-2",attrs:{"sm":_vm.compRightSM,"lg":_vm.compRightLG}},[_vm._t("right")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }